

import {
  FETCH_HEADER_SUCCESS,
  FETCH_HEADER_FAILURE,
  SHOW,
  HIDE,
  FOCUSED, PERSIST_SEARCH,
} from '../actionTypes';

import * as c from '../constants';

function reducer(state = c.DEFAULT_STATE, action) {
  // dispatch data received from search

  switch (action.type) {
    case SHOW:
      return {
        ...state,
        visible: true,
      };
    case HIDE:
      return {
        ...state,
        visible: false,
      };
    case PERSIST_SEARCH: {
      const persistedSearch = action.payload.length > 0 ? action.payload.join(' ') : null;
      return {
        ...state,
        persistedSearch,
      };
    }
    case FOCUSED:
      return {
        ...state,
        hasFocus: action.payload,
      };

    case FETCH_HEADER_SUCCESS:
      // data mod
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload,
        },
      };

    case FETCH_HEADER_FAILURE:
      return {
        ...state,
        error: action.error, // fallback on error
        data: action.payload,
      };
    default:
      return state;
  }
}

export default reducer;
